import React from 'react';
import { ReactComponent as ExclamationIcon } from '@blink/assets/src/icons/exclamation.svg';

import { usePoolDetailsStyle } from '@/pages/Pool/Pool.style';
import { Agreement, ROLE } from '@/shared/api/borrow';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/shared/ui';

interface PoolDetailsPanelProps {
    agreement: Agreement;
}
export const PoolDetailsPanel: React.FC<PoolDetailsPanelProps> = ({ agreement }) => {
    const classes = usePoolDetailsStyle();

    return (
        <div className={classes.main}>
            <div className={classes.tableWrapper}>
                <table className={classes.table}>
                    <thead>
                        <tr className={classes.tr}>
                            <th className={`${classes.asset}`}>Pool Information</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className={`${classes.tr}`}>
                            <td className={classes.firstTd}>
                                <div className={classes.param} data-testid='details-apy-label'>
                                    {agreement.role === ROLE.LENDER ? 'Supply APY' : 'Borrow APY'}
                                </div>
                                <div
                                    className={classes.subtitle}
                                    data-testid='details-apy-value'
                                >{`APY: ${agreement.apy}%`}</div>
                            </td>
                        </tr>
                        <tr className={`${classes.tr}`}>
                            <td className={classes.firstTd}>
                                <div className={classes.param}>
                                    <div data-testid='details-liquidation-label'>
                                        Liquidation Fee
                                    </div>
                                    <TooltipProvider>
                                        <Tooltip>
                                            <TooltipTrigger asChild>
                                                <ExclamationIcon />
                                            </TooltipTrigger>
                                            <TooltipContent side='bottom' sideOffset={30}>
                                                <p data-testid='details-tooltip-liquidation-content'>
                                                    A penalty charged when your position is
                                                    liquidated due to insufficient collateral.
                                                </p>
                                            </TooltipContent>
                                        </Tooltip>
                                    </TooltipProvider>
                                </div>
                                <div
                                    className={classes.subtitle}
                                    data-testid='details-liquidation-value'
                                >{`Fee: ${agreement.liquidationFee}%`}</div>
                            </td>
                        </tr>
                        <tr className={`${classes.tr}`}>
                            <td className={classes.firstTd}>
                                <div
                                    className={classes.param}
                                    data-testid='details-risk-factor-label'
                                >
                                    Risk Factor values
                                </div>
                                <div
                                    data-testid='details-margin-call-value'
                                    className={classes.subtitle}
                                >{`Margin Call: ${agreement.marginCallThreshold}`}</div>
                                <div
                                    className={classes.subtitle}
                                    data-testid='details-liquidation-threshold-value'
                                >
                                    {`Liquidation: ${agreement.liquidationThreshold}`}{' '}
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};
